export default String.raw`
{% if config.External.Edrone.AppId != '' -%}
    <script>
        if(cookieSettingsValue == undefined || cookieSettingsValue == 'granted' || cookieSettingsValue[0] == 'granted'){
            _edrone.action_type = 'order';

            {% assign FullName = cart.Customer.DeliveryAddress.Name -%}
            {% if FullName contains ' ' -%}
                {% assign HalfName = FullName | Split:' ' -%}
            {% endif %}
            _edrone.first_name = '{% if HalfName[0] -%}{{ HalfName[0] }}{% else %}{{ FullName }}{% endif %}';
            {% if HalfName[1] -%}
                _edrone.last_name = '{{ HalfName[1] }}';
            {% endif %}
            _edrone.country = '{{ cart.Customer.DeliveryAddress.Country }}';
            {% if cart.Customer.DeliveryAddress.City != '' -%}
                _edrone.city = '{{ cart.Customer.DeliveryAddress.City }}';
            {% endif %}
            {% if cart.Customer.DeliveryAddress.PhoneNo != '' -%}
                _edrone.phone = '{{ cart.Customer.DeliveryAddress.PhoneNo }}';
            {% endif %}
            _edrone.email = '{{ cart.Customer.Email }}';

            {% assign size = cart.PlacedOrder.Products | Size -%}
            {% capture edroneBase -%}{% include 'partials/common/absolute-base.html' -%}{% endcapture -%}
            var ids = '';
            var titles = '';
            var images = '';
            var skus = '';
            var urls = '';
            var categoryIds = '';
            var counts = '';
            {% for product in cart.PlacedOrder.Products -%}
                ids += '{{ product.Id }}{% if forloop.index != size -%}|{% endif -%}';
                titles += '{{ product.NameNoHtml }}{% if forloop.index != size -%}|{% endif -%}';
                images += '{% if product.ImageId > 0 -%}{{ edroneBase }}img/large/{{ product.ImageId }}/.jpg{% elsif product.Image.ExternalUrl != null and product.Image.ExternalUrl != '' -%}{{ product.Image.ExternalUrl | Replace: "'", '%27' }}{% endif -%}{% if forloop.index != size -%}|{% endif -%}';
                skus += '{{ product.Code }}{% if forloop.index != size -%}|{% endif -%}';
                urls += '{{ edroneBase }}{{ product.Url }}{% if forloop.index != size -%}|{% endif -%}';
                categoryIds += '{{ product.DefaultGroup }}{% if forloop.index != size -%}|{% endif -%}';
                counts += '{{ product.Quantity | Normalize }}{% if forloop.index != size -%}|{% endif -%}';
            {% endfor -%}

            _edrone.product_ids = ids;
            _edrone.product_titles = titles;
            _edrone.product_images = images;
            _edrone.product_skus = skus;
            _edrone.product_urls = urls;
            _edrone.product_category_ids = categoryIds;
            _edrone.product_counts = counts;

            _edrone.order_id = '{{ cart.PlacedOrder.Id }}';
            _edrone.base_currency = '{{ cart.Currency }}';
            _edrone.order_currency = '{{ cart.Currency }}';
            _edrone.base_payment_value = '{{ cart.OrderTotalValue | ToString | Replace:",","." }}';
            _edrone.order_payment_value = '{{ cart.OrderTotalValue | ToString | Replace:",","." }}';
            _edrone.init();
        }
    </script>
{% endif -%}
`